import { useEffect, useState } from 'react';
import { useAolStore } from 'src/context/AolContext';
import { useAuthStore } from 'src/context/AuthContext';
import { AolPageEnum } from 'src/enums/aol/AolPageEnum';
import { RoleTypeEnum } from 'src/enums/roleTypeEnum';

const useReadOnlyUtils = () => {
    const { role } = useAuthStore();
    const { selectedAolGroup, isEditGloballyMode } = useAolStore();
    const { activeAolPage } = useAolStore();
    const [isGlobalReadOnly, setIsGlobalReadOnly] = useState(false);

    useEffect(() => {
        const isWriter = role?.isWriter;

        if (!isWriter) setIsGlobalReadOnly(true);
        else if (isEditGloballyMode && isGlobalReadOnly) setIsGlobalReadOnly(false);
        setIsGlobalReadOnly(false);
    }, [selectedAolGroup, isEditGloballyMode, role]);

    const checkIsAolReadOnly = (sectionData?: any) => {
        if (isGlobalReadOnly) return true;
        if (isEditGloballyMode) return false;

        const isApproval = activeAolPage === AolPageEnum.Approval;
        const isBeforeOrcaWebStartDate = selectedAolGroup?.isBeforeOrcaWebStartDate;
        const isSectionEditable = sectionData && !sectionData.isApproved && !sectionData.isCompleted;

        return isApproval || isBeforeOrcaWebStartDate || !isSectionEditable;
    };

    const checkIsCargoTempLogReadOnly = () => {
        if (isGlobalReadOnly) return true;

        return !(
            role.roleType === RoleTypeEnum.Admin ||
            role.roleType === RoleTypeEnum.FleetPerformanceAnalyst ||
            role.roleType === RoleTypeEnum.ShipUser
        );
    };

    const checkIsTankCleaningReadOnly = () => {
        if (isGlobalReadOnly) return true;

        return !(role.roleType === RoleTypeEnum.Admin || role.roleType === RoleTypeEnum.ShipOperator || role.roleType === RoleTypeEnum.ShipUser);
    };

    return { checkIsAolReadOnly, checkIsCargoTempLogReadOnly, checkIsTankCleaningReadOnly };
};

export default useReadOnlyUtils;
